/**
 * SEO component that queries for data with
 *  Gatsby's useStaticQuery React hook
 *
 * See: https://www.gatsbyjs.org/docs/use-static-query/
 */

import React from "react";
import Helmet from "react-helmet";

interface SEOProps {
  title: string;
  description?: string;
  ogTitle?: string;
  imageUrl?: string;
  noIndex?: boolean;
  meta?: any[];
}

function SEO(props: SEOProps) {
  const metaDescription =
    props.description ||
    "BonusX stima il tuo ISEE e ti aiuta a scoprire e richiedere i bonus e le agevolazioni pubbliche a cui hai diritto, online. Semplice e veloce.";
  const metaImage = props.imageUrl || "/images/cover.jpeg";

  const widthImage = "1200";
  const heightImage = props.imageUrl ? "1024" : "630";

  const title = `BonusX | ${props.title}`;
  const ogTitle = `BonusX | ${props.ogTitle || props.title}`;

  const metaTags = [
    {
      name: `description`,
      content: metaDescription,
    },
    {
      property: `og:title`,
      content: ogTitle,
    },
    {
      property: `image`,
      content: metaImage,
    },
    {
      property: `og:image`,
      content: metaImage,
    },
    {
      property: `og:image:width`,
      content: widthImage,
    },
    {
      property: `og:image:height`,
      content: heightImage,
    },
    {
      property: `og:description`,
      content: metaDescription,
    },
    {
      property: `og:author`,
      content: `Mabiloft`,
    },
    {
      property: `og:site_name`,
      content: `Mabiloft`,
    },
    {
      property: `og:type`,
      content: `website`,
    },
    {
      name: `twitter:card`,
      content: `summary_large_image`,
    },
    {
      name: `twitter:creator`,
      content: "BonusX",
    },
    {
      name: `twitter:title`,
      content: ogTitle,
    },
    {
      name: `twitter:description`,
      content: metaDescription,
    },
  ];

  if (props.noIndex && props.noIndex === true) {
    metaTags.push({
      name: `robots`,
      content: `noindex`,
    });
  }

  return (
    <Helmet
      htmlAttributes={{ lang: "it-IT" }}
      title={title}
      // titleTemplate={`${site.siteMetadata.title} • %s `}
      meta={metaTags.concat(props.meta || [])}
    >
      <link rel="canonical" href={window.location.href} />
    </Helmet>
  );
}

export default SEO;
